import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { MOBILE_VIDEO_STATUS } from '../../config/consts';
import { useSiteContext } from '../../context/useSiteContext';
import { getCountMobileVideoFreeDevices } from '../../helpers/dashboard';
import DeviceForFreeTooltip from '../DeviceForFreeTooltip';
import messages from './messages';
import { styles } from './styles';

export function FreeDevices({
  devices,
  status,
}: {
  devices: Array<{ type: string; count: number }>;
  status: string;
}) {
  const { count } = getCountMobileVideoFreeDevices(devices);
  const isPerDeviceBillingType = useSiteContext().hasSiteBillingType('PER_DEVICE');

  const hasFreeDevices = count > 0 &&
    [MOBILE_VIDEO_STATUS.STANDARD, MOBILE_VIDEO_STATUS.TRIAL_ACTIVE, MOBILE_VIDEO_STATUS.TEMPORARY].includes(status);

  return hasFreeDevices && isPerDeviceBillingType ? (
    <Box sx={styles.text}>
      <DeviceForFreeTooltip isTooltip status={status}>
        <Typography variant="body2">
          <FormattedMessage
            {...messages.creditPoolCardFreeDevices}
            values={{
              count,
              span: (chunks: React.ReactNode) => (
                <Box component="span" sx={styles.number}>
                  {chunks}
                </Box>
              ),
              text: (chunks: React.ReactNode) => (
                <Box component="span" sx={styles.textColor}>
                  {chunks}
                </Box>
              ),
            }}
          />
        </Typography>
      </DeviceForFreeTooltip>
    </Box>
  ) : (
    <>{false}</>
  );
}
